import { render } from "./LeaveListTableHeader.vue?vue&type=template&id=10c9d440&scoped=true"
import script from "./LeaveListTableHeader.vue?vue&type=script&lang=js"
export * from "./LeaveListTableHeader.vue?vue&type=script&lang=js"

import "./LeaveListTableHeader.vue?vue&type=style&index=0&id=10c9d440&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c9d440"]])

export default __exports__